import React from 'react';
import InputEdit from 'components/common/input-edit';
import { withReason } from './hooks';

function Reason(props) {
  const { field, value, setInputs, schema } = props;
  return (
    <InputEdit
      field={field}
      schema={schema}
      setInputs={setInputs}
      value={value}
      className="basis-1/3"
      overrideSchema={{ is_required: true }}
    />
  );
}

export default withReason(Reason);
